import React, { useEffect } from 'react';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import useNavigate from '@swf/core/hooks/useNavigate';
import type { StaticContext } from '@swf/core/types/StaticContext';
import { TransactionHistoryWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const TransactionHistoryRoute: React.FC<{
  staticContext: StaticContext;
}> = ({ staticContext }) => {
  const SWCTransactionHistory = useFeature(FeatureFlag.SwcTransactionHistory);
  const navigate = useNavigate();

  useEffect(() => {
    if (!SWCTransactionHistory) {
      navigate('/');
    }
  }, [SWCTransactionHistory, navigate]);

  return SWCTransactionHistory ? (
    <FirstRoute component={TransactionHistoryWizard} staticContext={staticContext} noCache />
  ) : null;
};

export default TransactionHistoryRoute;
